import dayjs from "dayjs";
import utc from "dayjs/plugin/utc.js";
import timezone from "dayjs/plugin/timezone.js";

dayjs.extend(utc);
dayjs.extend(timezone);

// Zona horaria principal de la app
export const ZONA_HORARIA = "America/Bogota";

/**
 * Devuelve la fecha actual en la zona horaria configurada
 * Lista para guardar en DB
 */
export function ahora() {
  return dayjs().tz(ZONA_HORARIA).format(); // ISO string
}

/**
 * Convierte cualquier fecha a la zona horaria de la app
 */
export function convertirFecha(fecha) {
  return dayjs(fecha).tz(ZONA_HORARIA).format("DD/MM/YYYY HH:mm:ss");
}

export function formatearFechaHora(fecha) {
  return dayjs(fecha).tz(ZONA_HORARIA).format("DD/MM/YYYY HH:mm");
}

export function formatearFechaFactura(fecha) { 
  // fecha = "2026-02-16" 
  const [year, month, day] = fecha.split("-"); 
  const fechaLocal = new Date(year, month - 1, day);
return fechaLocal.toLocaleDateString("es-CO");


}

export function formatFechaFactura(f) 
{ if (!f) return "";
   const [year, month, day] = f.split("-"); 
   return `${day}/${month}/${year}`;
  
  }

export function formatFechaFiltros(f) 
{ if (!f) return "";
   const [year, month, day] = f.split("-"); 
   return `${day}/${month}/${year}`;
  
  }